
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import FileDownload from '@ecl/ec-react-component-file';
import demoContent from '@ecl/ec-specs-file/demo/data--without-translation';
import demoContentTranslation from '@ecl/ec-specs-file/demo/data--with-translation';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Without translations`}</h2>
    <Playground system="ec" selectedKind="components-file" selectedStory="without-translation" showFrame mdxType="Playground">
  <FileDownload {...demoContent} mdxType="FileDownload" />
    </Playground>
    <h2>{`With translations`}</h2>
    <Playground system="ec" selectedKind="components-file" selectedStory="with-translation" showFrame mdxType="Playground">
  <FileDownload {...demoContentTranslation} mdxType="FileDownload" />
    </Playground>
    <h2>{`JS behaviour`}</h2>
    <h3>{`Auto initialisation`}</h3>
    <p>{`In order to automatically initalise the JS behaviour, add `}<inlineCode parentName="p">{`data-ecl-auto-init="FileDownload"`}</inlineCode>{` to your component's markup:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="ecl-file" data-ecl-file data-ecl-auto-init="FileDownload">
  ...
</div>
`}</code></pre>
    <p>{`Don't forget to call `}<inlineCode parentName="p">{`ECL.autoInit()`}</inlineCode>{` when your page is ready!`}</p>
    <h3>{`Manual initialisation`}</h3>
    <p>{`When the document is ready, query the element. For example, you can use `}<inlineCode parentName="p">{`document.querySelector('[data-ecl-file]')`}</inlineCode>{` if you only have 1 file download in the page.`}</p>
    <p>{`Then, instantiate the `}<inlineCode parentName="p">{`FileDownload`}</inlineCode>{` component and call `}<inlineCode parentName="p">{`init()`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`var elt = document.querySelector('[data-ecl-file]');
var file = new ECL.FileDownload(elt);
file.init();
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;